"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.SHADOW_LEVEL4 = exports.SHADOW_LEVEL3 = exports.SHADOW_LEVEL2 = exports.SHADOW_LEVEL1 = void 0;
var shadowKeyPenumbraOpacity = 0.08;
var shadowAmbientShadowOpacity = 0.08;
function createShadow() {
    for(var _len = arguments.length, px = new Array(_len), _key = 0; _key < _len; _key++){
        px[_key] = arguments[_key];
    }
    return [
        "".concat(px[0], "px ").concat(px[1], "px ").concat(px[2], "px ").concat(px[3], "px rgba(0,0,66,").concat(shadowKeyPenumbraOpacity, ")"),
        "".concat(px[4], "px ").concat(px[5], "px ").concat(px[6], "px ").concat(px[7], "px rgba(0,0,66,").concat(shadowAmbientShadowOpacity, ")")
    ].join(',');
}
var shadows = [
    'none',
    createShadow(0, 1, 1, 0, 0, 1, 3, 0),
    createShadow(0, 2, 2, 0, 0, 1, 5, 0),
    createShadow(0, 3, 4, 0, 0, 1, 8, 0),
    createShadow(0, 4, 5, 0, 0, 1, 10, 0),
    createShadow(0, 5, 8, 0, 0, 1, 14, 0),
    createShadow(0, 6, 10, 0, 0, 1, 18, 0),
    createShadow(0, 7, 10, 1, 0, 2, 16, 1),
    createShadow(0, 8, 10, 1, 0, 3, 14, 2),
    createShadow(0, 9, 12, 1, 0, 3, 16, 2),
    createShadow(0, 10, 14, 1, 0, 4, 18, 3),
    createShadow(0, 11, 15, 1, 0, 4, 20, 3),
    createShadow(0, 12, 17, 2, 0, 5, 22, 4),
    createShadow(0, 13, 19, 2, 0, 5, 24, 4),
    createShadow(0, 14, 21, 2, 0, 5, 26, 4),
    createShadow(0, 15, 22, 2, 0, 6, 28, 5),
    createShadow(0, 16, 24, 2, 0, 6, 30, 5),
    createShadow(0, 17, 26, 2, 0, 6, 32, 5),
    createShadow(0, 18, 28, 2, 0, 7, 34, 6),
    createShadow(0, 19, 29, 2, 0, 7, 36, 6),
    createShadow(0, 20, 31, 3, 0, 8, 38, 7),
    createShadow(0, 21, 33, 3, 0, 8, 40, 7),
    createShadow(0, 22, 35, 3, 0, 8, 42, 7),
    createShadow(0, 23, 36, 3, 0, 9, 44, 8),
    createShadow(0, 5, 40, 0, 0, 3, 3, -3)
];
var SHADOW_LEVEL1 = exports.SHADOW_LEVEL1 = shadows[2];
var SHADOW_LEVEL2 = exports.SHADOW_LEVEL2 = shadows[3];
var SHADOW_LEVEL3 = exports.SHADOW_LEVEL3 = shadows[4];
var SHADOW_LEVEL4 = exports.SHADOW_LEVEL4 = shadows[24];
var _default = exports.default = shadows; //# sourceMappingURL=shadows.js.map
